import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=4e03d68f&"
import script from "./FileItem.vue?vue&type=script&lang=js&"
export * from "./FileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e03d68f')) {
      api.createRecord('4e03d68f', component.options)
    } else {
      api.reload('4e03d68f', component.options)
    }
    module.hot.accept("./FileItem.vue?vue&type=template&id=4e03d68f&", function () {
      api.rerender('4e03d68f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/FileItem.vue"
export default component.exports